import { Injectable } from '@angular/core';
import { TNil } from '@app/app.interface';

@Injectable({
  providedIn: 'root',
})
export class ExecutionExpectedKpisService {
  public static isExpectedValueSet(expectedValue: number | string | TNil): boolean {
    return expectedValue !== null && expectedValue !== undefined && expectedValue !== '';
  }

  public static isExpectedKpiVisible(
    expectedKpi: { exclusiveTo?: string | TNil },
    creatorId: string | TNil,
    isCustomMode: boolean,
    isViewMode: boolean,
  ): boolean {
    return !expectedKpi.exclusiveTo || isViewMode || (isCustomMode && expectedKpi.exclusiveTo === creatorId);
  }
}
